module.exports = __webpack_public_path__ + "img/product_6.4ce6ef7.webp";